var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"tech-container"},[_c('div',{staticClass:"image-container"},[_c('img',{staticClass:"link-image",attrs:{"src":require(`@/assets/images/linkIcons/${_vm.linkDetails.imgSrc}`)}})]),_c('div',{staticClass:"link-text"},[_vm._v(" "+_vm._s(_vm.linkDetails.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }